import * as ko from 'knockout';

export class SearchSuggetionRuntimeViewModel {
    public readonly suggested: ko.ObservableArray<string>;

    constructor() {
        this.suggested = ko.observableArray<string>([]);
    }
}
